import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export const buscarNotas = async function (data, basicUsuario) {
    try {
        const response = await api.post(`notafiscal/buscarNotas/filtro`, data, {
            headers: { "Content-Type": "application/json", Authorization: basicUsuario },
        })
        console.log("buscarNotas => ", response)
        return {
            response: response.data.response,
            message: response.data.message,
            status: response.status,
            statusText: response.statusText,
        }
    } catch (error) {
        RegistrarLogErro(error, "buscarNotas", data)
        return {
            response: [],
            message: `Buscar notas fisicas não foi possivel, tire uma foto desse erro e avise para os responsáveis. ${error.message}`,
            status: 1000,
            statusText: `error`,
        }
    }
}

export const sincronizarSituacaoNotaFiscal = async function (idPedido) {
    try {
        const response = await api.get(`notafiscal/sincronizarSituacao/${idPedido}`, {
            headers: { "Content-Type": "application/json" },
        })
        return {
            existe: true,
            status: response.status,
            data: response.data,
        }
    } catch (error) {
        if (error?.response?.status === 404) {
            return { existe: false, status: 404 }
        }
        const data = error?.response?.data
        const mensagem =
            data?.mensagem ||
            data?.message ||
            error.message ||
            "Não foi possível verificar a situação da nota fiscal."
        RegistrarLogErro(error, "sincronizarSituacaoNotaFiscal", { idPedido })
        return {
            retornoErro: 1,
            mensagem,
            status: error?.response?.status,
        }
    }
}

export const emitirNotaFiscalConsumidor = async function (idPedido, cpfCnpj) {
    try {
        const response = await api.post(
            `notafiscal/emitir/${idPedido}`,
            { cpfCnpj: cpfCnpj || "" },
            { headers: { "Content-Type": "application/json" } }
        )
        return {
            retornoErro: 0,
            status: response.status,
            data: response.data,
            mensagem: response.data?.mensagem,
        }
    } catch (error) {
        const data = error?.response?.data
        const errosLista = Array.isArray(data?.errors)
            ? data.errors
                  .map(e => (typeof e === "string" ? e : e?.message || e?.mensagem))
                  .filter(Boolean)
                  .join(" — ")
            : ""
        const mensagem =
            data?.mensagem ||
            data?.message ||
            errosLista ||
            error.message ||
            "Não foi possível emitir a nota fiscal."
        RegistrarLogErro(error, "emitirNotaFiscalConsumidor", { idPedido, cpfCnpj })
        return {
            retornoErro: 1,
            mensagem,
            status: error?.response?.status,
        }
    }
}

export const BaixarNotaFiscalPDF = async function (data, basicUsuario) {
    try {
        const response = await api.get("notafiscal/baixarNotaPDF/" + data, {
            responseType: "blob",
            headers: { "Content-Type": "application/json", Authorization: basicUsuario },
        })

        console.log("BaixarNotaFiscalPDF => ", response)

        // Não posso usar o tratamentoResponse, pois o retorno pode ser um PDF
        return response.data
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "BaixarNotaFiscalPDF", data)
    }
}
